var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16463_21378)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 20L1.72 14.8403C0.847241 13.3724 0.344828 11.6593 0.344828 9.82759C0.344828 4.4 4.74483 0 10.1724 0C15.6 0 20 4.4 20 9.82759C20 15.2552 15.6 19.6552 10.1724 19.6552C8.52103 19.6552 6.96586 19.2459 5.6 18.5266L0 20Z",
    fill: "#2CB742"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4421 13.0981C15.9883 12.2406 14.3149 11.2599 14.3149 11.2599C13.9363 11.044 13.4794 11.0199 13.2635 11.4047C13.2635 11.4047 12.7197 12.0568 12.5814 12.1506C11.9497 12.5785 11.3645 12.5619 10.7739 11.9712L9.40109 10.5985L8.02833 9.22573C7.43764 8.63504 7.42109 8.04987 7.84902 7.41815C7.94282 7.27987 8.59489 6.73608 8.59489 6.73608C8.97971 6.51987 8.95558 6.06332 8.73971 5.6847C8.73971 5.6847 7.75902 4.01125 6.90144 3.55746C6.53661 3.36435 6.08868 3.43194 5.79695 3.72366L5.19075 4.32987C3.26764 6.25297 4.21454 8.42401 6.13764 10.3471L7.89523 12.1047L9.65282 13.8623C11.5759 15.7854 13.747 16.7323 15.6701 14.8092L16.2763 14.203C16.568 13.9106 16.6352 13.4626 16.4421 13.0981Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16463_21378"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.671bb29485d56b5f484897206e6ad4b3.svg";
export { ForwardRef as ReactComponent };